module.exports = __webpack_public_path__ + "static/media/ary.c9757b71.svg";